var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getDatatypesMapper } from "@/components/Datatypes";
import { defineStore } from "pinia";
import { rethrowSimple } from "@/utils/simple-error";
export const useDatatypesMapperStore = defineStore("datatypesMapperStore", {
    state: () => ({
        datatypesMapper: null,
        loading: false,
    }),
    actions: {
        createMapper() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.loading && !this.datatypesMapper) {
                    this.loading = true;
                    try {
                        this.datatypesMapper = yield getDatatypesMapper(false);
                        this.loading = false;
                    }
                    catch (error) {
                        this.loading = false;
                        rethrowSimple(error);
                    }
                }
            });
        },
    },
});
